const userMenuLinks = [
  {
    title: "new_survey",
    url: "new-surveys",
  },
  {
    title: "completed_surveys",
    url: "completed-surveys",
  },
  {
    title: "my_rewards",
    url: "rewards",
  },
  {
    title: "my_profile",
    url: "profile",
  },
  {
    title: "my_contact_info",
    url: "contact-info",
  },
  {
    title: "security_settings",
    url: "security-settings",
  },
  {
    title: "withdraw_coin",
    url: "withdraw-coin",
  },
];

export default userMenuLinks